<template>
    <div class="preloader" id="site-preloader">
        <div class="preloader__image"></div>
    </div>
</template>

<script>
export default {
    name: "Preloader"
};
</script>
